import React, { useState } from "react";
import { Tag } from "antd";
import { connect } from "react-redux";
import { setAuditoria, fetch } from "../../actions";
import { InputPadrao, InputPasswordPadrao, LabelPadrao, LoadingContainerPadrao, ModalPadrao } from "../../components/Base";
import Mensagens from "../../components/Mensagens";
import { BtnPadrao, BtnSair } from "../../components/Buttons";

function ModalAuditoria({ ...props }) {
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(false);
    const [controller, setController] = useState(null);
    const online = props.online;

    const handleReject = rejectRet => {
        setUser({});

        if (!!controller)
            controller?.abort();

        props.auditoria.req.reject(rejectRet || { response: { status: 400, data: 'Auditoria não autorizada' } });

        props.setAuditoria("AUDITORIA_DEFAULT");
        setLoading(false);
        setController(null);
    };

    const onOk = (isRemoto, naoAuditar = false) => {
        setLoading(true);
        const cont = new AbortController();
        setController(cont);
        const req = auditoria.req;

        props.fetch().post(req.url, req.dados, { signal: cont.signal, headers: { ...auditoria.headers, naoAuditar, ...(isRemoto ? { usuarioRemoto: true } : { usuarioAuth: JSON.stringify(user) }) } }).then(s => {
            req.resolve(s);
            props.setAuditoria("AUDITORIA_DEFAULT");
            setUser({});
            setLoading(false);
        }).catch(error => {
            setLoading(false);
            const data = error?.response?.data;
            let msg = error?.response?.status === 400 && !!data ? data : "Falha na conexão";
            if (error?.response?.status == 503) {
                if (data.isAuditoria)
                    msg = 'Auditoria não autorizada';
                else
                    return handleReject(error);
            }

            if (!!msg)
                Mensagens.showErro(msg);
        });
    };

    const auditoria = props?.auditoria;

    return <>
        <ModalPadrao closable={false} width={500} title="Sem permissão" visible={!!auditoria && online} zIndex={50000} footer={<>
            <BtnPadrao type="primary" onClick={() => onOk(false)} disabled={loading}>Enviar</BtnPadrao>
            <BtnSair onClick={() => handleReject()} />
        </>}>
            <LoadingContainerPadrao loading={loading}>
                <LabelPadrao noMargin>Esse usuário não tem permissão para:</LabelPadrao>
                {auditoria?.auditorias?.map(x => <Tag key={x.id} style={{ display: "block", marginTop: 10, fontSize: 14, width: "100%" }} color="red" >{x.descricao}</Tag>)}
                <BtnPadrao type="primary" style={{ width: "100%", marginTop: 10 }} ghost onClick={() => onOk(true)}>Solicitar autorização remota</BtnPadrao>
                <LabelPadrao>Usuário</LabelPadrao>
                <InputPadrao placeholder="Informe o usuário" value={user.user} onChange={v => setUser({ ...user, user: v.target.value })} />
                <LabelPadrao>Senha</LabelPadrao>
                <InputPasswordPadrao placeholder="Informe a senha" value={user.pass} onChange={v => setUser({ ...user, pass: v.target.value })} />
            </LoadingContainerPadrao>
        </ModalPadrao>

        <ModalPadrao closable={false} width={600} title="Erro ao validar auditoria" visible={!!auditoria && !online} zIndex={50000} footer={<>
            <BtnSair onClick={() => handleReject()} disabled={loading} />
            <BtnPadrao type="primary" onClick={() => onOk(false, true)} loading={loading}>Sim</BtnPadrao>
        </>}>
            <div style={{ textAlign: "center" }}>
                <h2>Não foi possível validar a auditoria dessa operação</h2>
                <p>deseja continuar assim mesmo?</p>
            </div>
        </ModalPadrao>
    </>;
}

const mapStateToProps = state => ({ auditoria: state.auditoria, online: state.connection.online });

export default connect(mapStateToProps, { setAuditoria, fetch })(ModalAuditoria);